import { useState } from "react";
import { Row, Col, Card, Form, Button, Image, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useMounted } from "hooks/useMounted";
import http from "services/httpClient";

const ForgetPassword = () => {
  const hasMounted = useMounted();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);
    setError(null);
    setLoading(true); 

    try {
      await http.post("/auth/request-password-reset", {
        email,
      });
      setMessage("Password reset email sent. Please check your inbox.");
      setEmail("");
      
    } catch (err: any) {
      setError(err?.response?.data?.detail || "Failed to send reset email.");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Row className="align-items-center justify-content-center g-0 min-vh-100">
      <Col xxl={4} lg={6} md={8} xs={12} className="py-8 py-xl-0">
        <Card className="smooth-shadow-md">
          <Card.Body className="p-6">
            <div className="mb-4">
              <Link to="/">
                <Image
                  src="/images/brand/logo/logo-primary.svg"
                  className="mb-2"
                  alt=""
                />
              </Link>
              <p className="mb-6">
                Don&apos;t worry, we&apos;ll send you an email to reset your password.
              </p>
            </div>
            {hasMounted && (
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter Your Email"
                    required
                     disabled={loading}
                  />
                </Form.Group>

                <div className="mb-3 d-grid">
                  <Button variant="primary" type="submit" disabled={loading}>
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Sending...
                      </>
                    ) : (
                      "Reset Password"
                    )}
                  </Button>

                </div>
                <span>
                  Don&apos;t have an account? <Link to="/auth/sign-in">Sign In</Link>
                </span>

                {/* ⬇️ Move this to the bottom */}
                {message && (
                  <Alert className="mt-4 text-center" variant="success">
                    {message}
                  </Alert>
                )}
                {error && (
                  <Alert className="mt-4 text-center" variant="danger">
                    {error}
                  </Alert>
                )}
              </Form>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default ForgetPassword;
